import { UniqueIdentifier } from "@dnd-kit/core";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Col, Row } from "react-bootstrap";
import { ESolarSimBrands } from "../../../../../../shared/oversight-core/enums/solar-sim-brands";
import MaterialIcon from "../../../../../../shared/oversight-core/ui-elements/material-icon/material-icon";

interface IProps {
  id: UniqueIdentifier;
  brand: ESolarSimBrands;
}

export function BrandItem(props: IProps) {
  const { id, brand } = props;

  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    touchAction: "none",
    opacity: isDragging ? 0.6 : 1,
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes}>
      <Row
        className="rounded-3 py-2 theme-card my-1 mx-0"
        {...listeners}
        ref={setActivatorNodeRef}
      >
        <Col className="col-auto">
          <MaterialIcon icon="drag_pan" color="var(--color-theme-icon)" />
        </Col>
        <Col className="font-weight-500 title-2">{brand}</Col>
      </Row>
    </div>
  );
}
